import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** A titled card while its numbers load: the card's frame, its header bars and three rows, about as tall as the loaded one. */
export function SummaryCardSkeleton() {
  return (
    <Card className="py-0 gap-0">
      <CardHeader className="px-5 py-4 gap-0 border-b">
        <Skeleton className="h-5 w-40 mb-1" />
        <Skeleton className="h-4 w-3/4" />
      </CardHeader>
      <CardContent className="p-5 space-y-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </CardContent>
    </Card>
  );
}

/** The template page while it loads: the header row, the tab strip and one card (AgencyDetailSkeleton's shape). */
export function TemplateDetailSkeleton() {
  return (
    <div className="space-y-6 w-full pb-12">
      <div className="flex items-center gap-3">
        <Skeleton className="h-9 w-9 rounded-md" />
        <Skeleton className="h-8 w-[250px]" />
        <Skeleton className="h-5 w-[70px] rounded-full" />
      </div>

      <div className="flex gap-2 border-b">
        <Skeleton className="h-10 w-[90px] rounded-t-md rounded-b-none" />
        <Skeleton className="h-10 w-[120px] rounded-t-md rounded-b-none" />
        <Skeleton className="h-10 w-[100px] rounded-t-md rounded-b-none" />
      </div>

      <Card className="py-0 gap-0 shadow-sm">
        <CardHeader className="px-5 py-4 gap-0 border-b">
          <Skeleton className="h-5 w-[140px] mb-1" />
          <Skeleton className="h-4 w-[180px]" />
        </CardHeader>
        <CardContent className="p-5 space-y-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="space-y-2">
              <Skeleton className="h-4 w-[100px]" />
              <Skeleton className="h-9 w-full" />
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
